var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('h1',[_vm._v("Chat Invite")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }